module.exports = __webpack_public_path__ + "static/media/PL.836eee9f.svg";